import { Box, Container } from "@mui/material";
import { AppBar } from "Components/_Shared/AppBar/AppBar";
import { Spacing } from "Infrastructure/Themes/Themes";
import { type FC, type PropsWithChildren, useEffect } from "react";

type Props = {
  readonly appBarVariant?: "light" | "dark";
  readonly container?: boolean;
  readonly title: string;
};

export const AuthenticatedLayout: FC<PropsWithChildren<Props>> = ({ appBarVariant, children, title, container = true }) => {
  useEffect(() => {
    document.title = `${title} | Analyzátor`;
  }, [title]);

  return (
    <>
      <AppBar variant={appBarVariant} />
      {container ? (
        <Container>
          <Box py={Spacing.XXXL}>{children}</Box>
        </Container>
      ) : (
        children
      )}
    </>
  );
};
